//@flow
import * as React from 'react';
import { useIsSettingsSectionEnabled } from './useIsSettingsSectionEnabled';
import useClientId from 'common/hooks/useClientId';
import { useTranslation } from 'react-i18next';
// Tech Debt: Might result in circular dependency. Needs refactor
import LeftBarItem from 'container/components/navigation/LeftBarItem';

export const SettingsLink = ({
    theme,
    isActive
}: {
    isActive: boolean,
    theme: Object
}): React.Node => {
    const isEnabled = useIsSettingsSectionEnabled();
    const clientId = useClientId();
    const { t } = useTranslation();
    if (isEnabled) {
        return (
            <LeftBarItem
                theme={theme}
                to={`/client/${clientId}/settings`}
                active={isActive}
                tooltip={t('container:settings.leftbarItem.tooltip')}
                icon="dashboard_settings"
                testId="settingsSidebar"
            />
        );
    }
    return null;
};
